var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"id":"login","loading":_vm.loggingIn}},[_c('v-card-actions',[_c('div',{attrs:{"id":"firebaseui-auth-container"}}),_c('v-btn',{on:{"click":_vm.cancel}},[_vm._v("Cancel")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }